import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ErrorDisplayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
`;

const LostGuyImage = styled.img`
  max-width: 400px;
  margin-bottom: 18px;
`;

function ErrorDisplay({ image, title, description }) {
  return (
    <ErrorDisplayWrapper>
      <LostGuyImage
        src={image}
        alt="imagem sobre o erro"
      />
      <div>
        <h2>{title}</h2>
        <span>{description}</span>
      </div>
    </ErrorDisplayWrapper>
  );
}

ErrorDisplay.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ErrorDisplay;
